import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useEmulation } from '../contexts/EmulationContext'
import './EmulationBanner.scss'

const EmulationBanner = () => {
  const { t } = useTranslation('common')
  const { isEmulating, emulatedUser, endEmulation } = useEmulation()
  const [ending, setEnding] = useState(false)
  const [error, setError] = useState(null)
  const navigate = useNavigate()

  if (!isEmulating || !emulatedUser) {
    return null
  }

  const handleExit = async () => {
    setEnding(true)
    setError(null)
    try {
      console.log('[EmulationBanner] Ending emulation...')
      const result = await endEmulation()
      console.log('[EmulationBanner] End result:', result)
      if (result.success) {
        // Navigate to users page where admin can emulate another user
        console.log('[EmulationBanner] End successful, navigating to users...')
        navigate('/users')
      } else {
        // API failed - show error and don't reload
        console.error('[EmulationBanner] Failed to end emulation:', result.error)
        setError(result.error || 'Failed to end emulation')
        setEnding(false)
      }
    } catch (err) {
      console.error('[EmulationBanner] Error ending emulation:', err)
      setError(err.message || 'Failed to end emulation')
      setEnding(false)
    }
  }

  const userName = emulatedUser.firstName && emulatedUser.lastName
    ? `${emulatedUser.firstName} ${emulatedUser.lastName}`
    : emulatedUser.email

  return (
    <div className="emulation-banner">
      <span className="emulation-banner__icon" role="img" aria-label="viewing">
        &#128065;
      </span>
      <span className="emulation-banner__text">
        {t('emulation.viewingAs', 'Viewing as')}
        <span className="emulation-banner__user-name">{userName}</span>
      </span>
      {error && (
        <span className="emulation-banner__error">
          {error}
        </span>
      )}
      <button
        type="button"
        className="emulation-banner__exit-btn"
        onClick={handleExit}
        disabled={ending}
      >
        {ending ? t('emulation.exiting', 'Exiting...') : t('emulation.exitButton', 'Exit View')}
      </button>
    </div>
  )
}

export default EmulationBanner
